import React from 'react';

const SingleAppointment = (props) => {
  const { itemClass, title, startTime, endTime, description } = props;
  return (
    <div className={itemClass ? itemClass : 'it-appointment-content'}>
      <a href="#">{title ? title : 'Laboratory'}</a>
      <p>
        <i>{startTime ? startTime : '1:00 am'}</i>
        <span> - </span>
        <i>{endTime ? endTime : '3:00 am'}</i>
      </p>
      <p>{description ? description : 'Medical Scanner'}</p>
    </div>
  );
};

export default SingleAppointment;
